import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("strong", null, "cannot be changed", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message = _resolveComponent("message")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_message, {
      type: "warning",
      class: "q-mb-md"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Client details "),
        _hoisted_1,
        _createTextVNode(" after they have been added. "),
        _hoisted_2,
        _createTextVNode(" Please ensure the details below are correct before proceeding. ")
      ]),
      _: 1
    }),
    _createVNode(_component_q_list, {
      bordered: "",
      class: "radius"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _createTextVNode("Name")
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, {
              class: "text-subtitle2",
              avatar: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.lastName) + ", " + _toDisplayString(_ctx.firstName), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _createTextVNode("Email")
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, {
              class: "text-subtitle2",
              avatar: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.email), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _createTextVNode("Phone Number")
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, {
              class: "text-subtitle2",
              avatar: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.phone), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _createTextVNode("Date of Birth")
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, {
              class: "text-subtitle2",
              avatar: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$filters.date(_ctx.dateOfBirth)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_separator),
        (_ctx.fileRefNo)
          ? (_openBlock(), _createBlock(_component_q_item, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createTextVNode("File Reference Number")
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, {
                  class: "text-subtitle2",
                  avatar: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.fileRefNo), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _createTextVNode("Date of Loss")
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, {
              class: "text-subtitle2",
              avatar: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$filters.date(_ctx.dateOfLoss)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}